import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { FiEye, FiEyeOff } from "react-icons/fi";
import api from "../../api/api";
import { Backdrop, CircularProgress } from "@mui/material";
import Footer from "../../auth/Footer";

const SubcontractorLogin = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (!username) {
      setError("Username is required.");
      return;
    }
    if (!password) {
      setError("Password is required.");
      return;
    }

    setLoading(true);
    const params = new URLSearchParams();
    params.append("username", username);
    params.append("password", password);

    try {
      const response = await api.post("/auth/token", params, {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      if (response.status === 200 && response.access_token) {
        sessionStorage.setItem("subcontractorToken", response.access_token);
        sessionStorage.setItem("accessToken", response.access_token);
        sessionStorage.setItem("subcontractorUserId", response.id);
        sessionStorage.setItem("subcontractorUserName", response.data[0]?.firstname || username);
        navigate(
          `/subcontractor-form?allow=${response.access_token}`
        );
      } else {
        setError(response.message || "Invalid credentials. Please try again.");
      }
    } catch (err) {
      console.error(err);
      setError("Login failed. Please check your details and try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-gray-100">
      <Backdrop open={loading} sx={{ zIndex: 9999 }}>
        <CircularProgress />
      </Backdrop>

      <div className="flex flex-grow items-center justify-center px-4">
        <div className="bg-white p-6 md:p-8 rounded-lg shadow-custom-dark w-full max-w-[660px] h-auto flex flex-col justify-center">
          <div className="flex justify-center my-8">
            <img
              src="https://ai.brainymed.com/ntact/public//assets/images/logo.png?id=2025030410"
              alt="Logo"
              className="w-50 h-auto"
            />
          </div>

          <div className="text-md font-inter mb-1 text-start text-[#6c757d]">Enter Username</div>
          <input
            type="text"
            placeholder="Username"
            value={username}
            onChange={(e) => {
              setUsername(e.target.value);
              setError("");
            }}
            className="w-full px-3 py-2 border border-gray-300 rounded mb-6 focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <div className="text-start text-[#6c757d] text-md font-inter mb-1">Enter Password</div>
          <div className="relative w-full">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
              className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 pr-12"
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-3 flex items-center text-gray-500"
            >
              {showPassword ? <FiEyeOff size={20} /> : <FiEye size={20} />}
            </button>
          </div>

          {error && <div className="text-red-600 text-sm mt-2 mb-2">{error}</div>}

          <button
            onClick={handleLogin}
            disabled={loading}
            className={`w-full px-3 py-2 mt-8 text-white rounded-md text-md font-inter transition duration-300 ${
              loading ? "bg-gray-400 cursor-not-allowed" : "bg-[#145388] hover:bg-[#0f3a66]"
            }`}
          >
            {loading ? "Logging in..." : "Login"}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default SubcontractorLogin;
